import { api } from "@/lib/api";

const base = "/api/receivables";

export type ReceivablePaymentStatus = "UNPAID" | "PARTIALLY_PAID" | "PAID";

export type ReceivableRow = {
  id: string;
  hospitalId: string;
  receivableNumber?: string | null;
  hospitalUnit: string;
  receivableType: string;
  counterpartyName: string;
  description?: string | null;
  amount: number;
  invoiceNo?: string | null;
  receivableDate: string;
  dueDate?: string | null;
  paymentMode?: string | null;
  paymentStatus: ReceivablePaymentStatus;
  collectedAmount: number;
  collectedAt?: string | null;
  createdByName?: string | null;
  createdAt: string;
  hospital?: { id: string; name: string } | null;
};

export type ReceivableMeta = {
  paymentModes: string[];
  paymentStatuses: string[];
  hospitalUnits: string[];
};

export type CreateReceivableBody = {
  receivableType: string;
  counterpartyName: string;
  description?: string;
  amount: number;
  invoiceNo?: string;
  receivableDate?: string;
  dueDate?: string;
  paymentMode?: string;
  hospitalUnit?: string;
  targetHospitalId?: string;
};

function unwrap<T>(res: { data?: { data?: T } }): T {
  return res.data?.data as T;
}

export const receivablesApi = {
  meta: () => api.get(`${base}/meta`).then((r) => unwrap<ReceivableMeta>(r)),
  listLookups: (kind: "RECEIVABLE_TYPE" | "COUNTERPARTY") =>
    api.get(`${base}/lookups`, { params: { kind } }).then((r) => unwrap<{ names: string[] }>(r)),
  createLookup: (body: {
    kind: "RECEIVABLE_TYPE" | "COUNTERPARTY";
    name: string;
    hospitalId?: string;
    hospitalUnit?: string;
    targetHospitalId?: string;
  }) => api.post(`${base}/lookups`, body).then((r) => unwrap<{ name: string }>(r)),
  list: (params?: Record<string, string>) =>
    api.get(`${base}`, { params }).then((r) => unwrap<ReceivableRow[]>(r)),
  create: (body: CreateReceivableBody) =>
    api.post(`${base}`, body).then((r) => unwrap<ReceivableRow>(r)),
  update: (id: string, body: Partial<CreateReceivableBody>) =>
    api.patch(`${base}/${id}`, body).then((r) => unwrap<ReceivableRow>(r)),
  markCollected: (id: string, paymentMode: string, collectedAt?: string) =>
    api
      .post(`${base}/${id}/mark-collected`, { paymentMode, collectedAt })
      .then((r) => unwrap<ReceivableRow>(r)),
  unmarkCollected: (id: string) =>
    api.post(`${base}/${id}/unmark-collected`).then((r) => unwrap<ReceivableRow>(r)),
  remove: (id: string) => api.delete(`${base}/${id}`).then((r) => unwrap<{ id: string }>(r)),
};
